import React from 'react';
import styles from './CustomNewConfirm.module.css';
import CustomNewButton from 'components/NewDesign/CustomNewButton';
import WarningText from 'components/NewDesign/WarningText';
import PropTypes, { bool } from 'prop-types';

const CustomNewConfirm = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  confirmButtonText = 'Confirm',
  confirmButtonVariant = 'primary',
  onConfirm,
  cancelButtonText = 'Cancel',
  onCancel,
  showImpactSummary = false,
  impactItems = [],
  showWarning = false,
  warningText = '',
  showValidationRules = false,
  validationRules = [],
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    // No overlay onClick — dialogs must not close on an outside click (only the × / Cancel / Confirm).
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
          <button className={styles.closeBtn} onClick={onClose}>
            &times;
          </button>
        </div>
        <div className={styles.modalBody}>
          {description && (
            <div className={styles.modalDescription}>{description}</div>
          )}

          {showImpactSummary && impactItems.length > 0 && (
            <div className={styles.impactSummary}>
              {impactItems.map((item, index) => (
                <div key={index} className={styles.impactItem}>
                  <span className={styles.impactLabel}>{item.label}</span>
                  <span className={styles.impactValue}>{item.value}</span>
                </div>
              ))}
            </div>
          )}

          {showWarning && warningText && <WarningText text={warningText} />}

          {children}

          {showValidationRules && validationRules.length > 0 && (
            <div className={styles.validationRules}>
              <div className={styles.validationRulesTitle}>Date Rules</div>
              <ul>
                {validationRules.map((rule, index) => (
                  <li key={index}>{rule}</li>
                ))}
              </ul>
            </div>
          )}

          <div className={styles.modalActions}>
            <CustomNewButton
              label={cancelButtonText}
              variant="secondary"
              onClick={onCancel || onClose}
            />
            <CustomNewButton
              label={confirmButtonText}
              variant={confirmButtonVariant}
              onClick={onConfirm}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CustomNewConfirm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  children: PropTypes.node,
  confirmButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  onCancel: PropTypes.func,
  showImpactSummary: PropTypes.bool,
  impactItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  showWarning: PropTypes.bool,
  warningText: PropTypes.string,
  showValidationRules: PropTypes.bool,
  validationRules: PropTypes.arrayOf(PropTypes.string),
  isLoading: bool,
};

export default CustomNewConfirm;
